export default () => {
  try {
    const userId = sessionStorage.getItem('userId') ?? '';
    const accountId = sessionStorage.getItem('currentAccountId') ?? '';
    const usersPreferences = JSON.parse(localStorage.getItem('usersPreferences')) ?? {};
    const { settings } = usersPreferences?.[userId] ?? {};
    const { accounts } = settings ?? {};
    const { currentChannel } = accounts?.[accountId] ?? {};
    return parseInt(currentChannel, 10);
  } catch (e) {
    // if there is an error it is likely caused by invalid JSON. In this case we should return
    // null. The calling function will fall back on defaults for channel
    return null;
  }
};
